import {
  useGetVerificationTaskQuery,
  GetVerificationTaskQueryVariables
} from "Shared/graphql/generated";

import { getAffiliationFormInitialValues } from "../helpers";

export const useGetVerificationTask = (
  variables: GetVerificationTaskQueryVariables
) => {
  const { data, loading, refetch } = useGetVerificationTaskQuery({
    variables,
    fetchPolicy: "no-cache"
  });

  const {
    data: taskData,
    completed,
    updated,
    completedBy,
    phoneNumbers,
    affiliation,
    lastSession
  } = data?.getVerificationTask || {};

  const institution = affiliation?.personInstitution.institution;
  const { name } = institution || {};
  const { institutionAddress } = institution || {};
  const address = institutionAddress?.address;
  const orgType = taskData?.orgType?.orgTypeLevel1;

  const validationFormInitialValues = getAffiliationFormInitialValues({
    taskData,
    phoneNumbers,
    notes: lastSession?.notes
  });
  return {
    completed,
    phoneNumbers,
    name,
    address,
    updated,
    completedBy,
    orgType,
    lastSession,
    validationFormInitialValues,
    isLoading: loading,
    refetch
  };
};
